function getOccupancyLevel(percentage) {
  if (percentage < 25) {
    return "low";
  }

  if (percentage < 50) {
    return "moderate";
  }

  if (percentage < 75) {
    return "middle";
  }

  if (percentage < 95) {
    return "high";
  }

  return "full";
}

export { getOccupancyLevel };
